import { AsyncAction } from 'src/utils/reduxUtils'
import { ApiService, callClientSecureApi } from './api/callApi'
import { call, put, takeLatest } from 'redux-saga/effects'
import { Endpoints } from 'src/constants/endpoints'
import { FetchDriver, UploadDOTNumber } from 'src/constants/actionTypes'
import { captureSentryError } from 'src/utils/sentry'
import { getApiErrorMessage } from 'src/utils/errorHandlers'
import { GcsFileReferenceDto, uploadFileToGcs } from './api/gcsUpload'

interface UploadDOTNumberRequest {
  dotNumber: string
  stateOfIssue: string
  stepId: string
  lastSubmittedAt: string
  file?: File
}

function* onUploadDOTNumber(action: AsyncAction<UploadDOTNumberRequest>) {
  const { dotNumber, stateOfIssue, stepId, lastSubmittedAt, file } = action.payload

  try {
    let fileRef: GcsFileReferenceDto | undefined

    if (file) {
      fileRef = (yield call(
        uploadFileToGcs,
        {
          stepId,
          originalname: file.name,
          mimeType: file.type,
          size: file.size,
        },
        file,
      )) as GcsFileReferenceDto
    }

    yield call(callClientSecureApi, Endpoints.UploadDOTNumber, {
      method: 'POST',
      body: { stepId, dotNumber, stateOfIssue, lastSubmittedAt, file: fileRef },
      apiService: ApiService.Paraworks,
    })

    yield put(UploadDOTNumber.success())

    yield put(FetchDriver.request())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.dotNumber.onUploadDOTNumber] error',
    })

    const errorMessage = getApiErrorMessage(err, 'Failed to upload DOT number')

    yield put(UploadDOTNumber.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* dotNumberSaga() {
  yield takeLatest(UploadDOTNumber.type.REQUEST, onUploadDOTNumber)
}
